<script>
export default {
  name: 'ChartjsLegend',
  props: {
    datasets: {
      type: Array,
      required: true,
    },
    onToggle: {
      type: Function,
      required: true,
    },
  },
  methods: {
    toggleDataset(index) {
      this.onToggle(index)
    },
  },
}
</script>

<template>
  <div class="legend-chart">
    <div
      v-for="(dataset, index) in datasets"
      :key="index"
      class="legend-item"
      :class="{ linha: dataset.hidden }"
      :style="{
        cursor: 'pointer',
        '--dataset-color': dataset.backgroundColor || dataset.borderColor,
      }"
      @click="toggleDataset(dataset.label)"
    >
      <span
        :style="{
          backgroundColor: dataset.backgroundColor || dataset.borderColor,
        }"
        class="legend-color"
      ></span>
      <span class="legend-label">{{ dataset.label }}</span>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.legend-chart
  display: flex
  gap: 16px
  flex-wrap: wrap
  align-items: center
  justify-content: center
  .legend-item
    display: flex
    align-items: center
    transition: all 0.2s ease-in-out
    &:hover
      //scale: 1.01
      color: var(--dataset-color)
      font-weight: bold
  .legend-color
    width: 12px
    height: 12px
    border-radius: 50%
    margin-right: 8px
  .linha
    text-decoration: line-through
</style>
